export const getSdk = () => window.paypal;
